/**
 * Console Transport
 *
 * Pretty-prints log entries to the browser console with color-coded levels.
 * Used in development mode.
 */

import type { FrontendLogEntry, LogTransport } from '../types';

const LEVEL_COLORS: Record<string, string> = {
  debug: 'color: #9ca3af',
  info: 'color: #3b82f6',
  warn: 'color: #f59e0b',
  error: 'color: #ef4444',
};

const LEVEL_METHODS: Record<string, 'log' | 'info' | 'warn' | 'error'> = {
  debug: 'log',
  info: 'info',
  warn: 'warn',
  error: 'error',
};

export class ConsoleTransport implements LogTransport {
  write(entry: FrontendLogEntry): void {
    const method = LEVEL_METHODS[entry.level] ?? 'log';
    const color = LEVEL_COLORS[entry.level] ?? 'color: inherit';
    const prefix = `[${entry.service}]`;
    const correlationTag = entry.correlationId ? ` cid=${entry.correlationId}` : '';

    // eslint-disable-next-line no-console
    console[method](
      `%c${entry.timestamp} ${entry.level.toUpperCase()} ${prefix}${correlationTag} ${entry.message}`,
      color,
      entry.context ?? '',
      entry.error ?? '',
    );
  }

  async flush(): Promise<void> {
    // Console transport has no buffer
  }
}
